/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BatchServiceResponseResultsInner } from './BatchServiceResponseResultsInner';
import {
    BatchServiceResponseResultsInnerFromJSON,
    BatchServiceResponseResultsInnerFromJSONTyped,
    BatchServiceResponseResultsInnerToJSON,
} from './BatchServiceResponseResultsInner';

/**
 * 
 * @export
 * @interface BatchServiceResponse
 */
export interface BatchServiceResponse {
    /**
     * 
     * @type {boolean}
     * @memberof BatchServiceResponse
     */
    success: boolean;
    /**
     * 
     * @type {Array<BatchServiceResponseResultsInner>}
     * @memberof BatchServiceResponse
     */
    results: Array<BatchServiceResponseResultsInner>;
}

/**
 * Check if a given object implements the BatchServiceResponse interface.
 */
export function instanceOfBatchServiceResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function BatchServiceResponseFromJSON(json: any): BatchServiceResponse {
    return BatchServiceResponseFromJSONTyped(json, false);
}

export function BatchServiceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchServiceResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'results': ((json['results'] as Array<any>).map(BatchServiceResponseResultsInnerFromJSON)),
    };
}

export function BatchServiceResponseToJSON(value?: BatchServiceResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'results': ((value.results as Array<any>).map(BatchServiceResponseResultsInnerToJSON)),
    };
}

